// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RotateRightOutlinedSvg from "@ant-design/icons-svg/es/asn/RotateRightOutlined";
import AntdIcon from '../components/AntdIcon';

var RotateRightOutlined = function RotateRightOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RotateRightOutlinedSvg
  }));
};

RotateRightOutlined.displayName = 'RotateRightOutlined';
export default React.forwardRef(RotateRightOutlined);